import {createSlice} from '@reduxjs/toolkit';
import omit from 'lodash/omit';
import without from 'lodash/without';

/**
 *
 * @typedef {object} TEventPricingDefaultSliceInitialState
 * @property {object} filters
 * @property {string} filters.fromDate - The start date for the events in the format MM/DD/YYYY.  Defaults to the current date
 * @property {string} filters.toDate - The end date for the events in the format MM/DD/YYYY.  Defaults to the end of the current month
 */
export const initialState = {
    filters: {
        venueId: 'all',
        numFiltersApplied: 0,
    },
};

const EventPricingDefaultSlice = createSlice({
    name: 'events/eventPricingDefaults',
    initialState,
    reducers: {
        /**
         * Updates the filters for the events report
         * @memberof Events.Actions
         * @param {TEventPricingDefaultSliceInitialState} [state] - The current state
         * @param {object} payload - The new filters
         * @param {string} payload.fromDate - The start date for the events in the format MM/DD/YYYY.
         * @param {string} payload.toDate - The end date for the events in the format MM/DD/YYYY.
         * @param {string} payload.venueId - The venue id for the events.
         */
        updateFilters: {
            reducer: (state, {payload}) => {
                state.filters = payload;
            },
            prepare: (payload) => {
                const initialFilters = omit(
                    initialState.filters,
                    'numFiltersApplied'
                );

                const appliedFilters = without(
                    Object.values(payload),
                    ...Object.values(initialFilters)
                );

                return {
                    payload: {
                        ...payload,
                        numFiltersApplied: appliedFilters.length,
                    },
                };
            },
        },
        /**
         * Resets the filters for the events report
         * @param {TEventPricingDefaultSliceInitialState} state
         */
        resetFilters: (state) => {
            state.filters = initialState.filters;
        },
    },
});

export const {updateFilters, resetFilters} = EventPricingDefaultSlice.actions;

export default EventPricingDefaultSlice.reducer;
